/**
 *
 *
 */
export function decodeHtml(html: string): string {
    const namedEntities: Record<string, string> = {
        amp: '&',
        quot: '"',
        apos: "'",
        lt: '<',
        gt: '>',
        '#39': "'",
    };

    return html.replace(/&(#x?[0-9a-fA-F]+|[a-zA-Z]+);/g, (entity, code) => {
        const normalized = String(code);
        if (normalized[0] === '#') {
            const isHex = normalized[1]?.toLowerCase() === 'x';
            const num = Number.parseInt(normalized.slice(isHex ? 2 : 1), isHex ? 16 : 10);
            return Number.isNaN(num) ? entity : String.fromCodePoint(num);
        }

        return namedEntities[normalized] ?? entity;
    });
}
